import { render, staticRenderFns } from "./GameAccountLinker.vue?vue&type=template&id=3724fad0&scoped=true"
import script from "./GameAccountLinker.vue?vue&type=script&lang=js"
export * from "./GameAccountLinker.vue?vue&type=script&lang=js"
import style0 from "./GameAccountLinker.vue?vue&type=style&index=0&id=3724fad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724fad0",
  null
  
)

export default component.exports